/**
 * Checks if a type string represents a complex object type that should be displayed
 * as formatted code rather than a simple tag.
 *
 * Complex types include:
 * - Multi-line object definitions
 * - Nested object structures
 */
export const isComplexObjectType = (type: string): boolean => {
  // Check if type contains newlines (multi-line structure)
  if (type.includes("\n")) {
    return true;
  }

  // Check if it's a deeply nested object (contains multiple levels of object definitions)
  const objectCount = (type.match(/object\(/g) || []).length;
  if (objectCount > 1) {
    return true;
  }

  return false;
};
